function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28.9221 26.2833C24.8131 31.7129 17.1924 33.3676 11.1496 29.8787C5.10674 26.3899 2.72941 18.9629 5.37705 12.6895L2.37883 10.9585C-1.19896 18.8831 1.75125 28.4116 9.4353 32.848C17.1193 37.2843 26.8463 35.0751 31.9203 28.0143L28.9221 26.2833ZM31.577 16.1402C31.9053 18.518 31.6127 20.9936 30.6364 23.3141L33.6346 25.0451C35.0598 21.8935 35.4322 18.4897 34.8976 15.2505L31.577 16.1402ZM27.0463 7.70194C28.6704 9.13448 29.9026 10.8975 30.6897 12.8288L34.0103 11.9391C32.9907 9.23179 31.2907 6.76565 28.9852 4.8392L27.0463 7.70194ZM19.6628 4.40565C21.2086 4.59443 22.7449 5.04066 24.2034 5.78223L26.1356 2.93109C24.0666 1.81385 21.8575 1.18024 19.6441 0.969379L19.6628 4.40565ZM12.9185 5.30588C13.9819 4.88369 15.0955 4.57552 16.2324 4.42775L16.217 0.985681C14.5051 1.16494 12.8254 1.61014 11.2401 2.28002L12.9185 5.30588Z",
  fill: "#0851DF"
});

var SvgLoading = function SvgLoading(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoading, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loading.8a8a99d1.svg";
export { ForwardRef as ReactComponent };